var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_714",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74376 25.9999C5.07025 25.9999 4.50016 25.7666 4.0335 25.2999C3.56683 24.8333 3.3335 24.2632 3.3335 23.5897V8.41027C3.3335 7.73676 3.56683 7.16667 4.0335 6.7C4.50016 6.23333 5.07025 6 5.74376 6H26.2565C26.93 6 27.5001 6.23333 27.9668 6.7C28.4334 7.16667 28.6668 7.73676 28.6668 8.41027V23.5897C28.6668 24.2632 28.4334 24.8333 27.9668 25.2999C27.5001 25.7666 26.93 25.9999 26.2565 25.9999H5.74376ZM16.0001 16.7435L5.33346 9.923V23.5897C5.33346 23.7093 5.37193 23.8076 5.44886 23.8846C5.5258 23.9615 5.6241 24 5.74376 24H26.2565C26.3762 24 26.4745 23.9615 26.5514 23.8846C26.6283 23.8076 26.6668 23.7093 26.6668 23.5897V9.923L16.0001 16.7435ZM16.0001 14.6666L26.4617 7.99997H5.5386L16.0001 14.6666ZM5.33346 9.923V7.99997V23.5897C5.33346 23.7093 5.37193 23.8076 5.44886 23.8846C5.5258 23.9615 5.6241 24 5.74376 24H5.33346V9.923Z",
    fill: "#F7F7F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ac912c0cf5219334960ad24a76e5295b.svg";
export { ForwardRef as ReactComponent };